import React, { Component } from "react";
import {
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  ButtonDropdown
} from "reactstrap";
import { ButtonDropDownWithAuth } from "../../authComponents/authComponents";
import "./UserActivity.scss";
const apiCalls = require("../../ApiCalls");

class UserIdSearch extends Component {
  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.setSearchFilter = this.setSearchFilter.bind(this);
    this.state = {
      searchFilter: "Username",
      searchTitle: "Username",
      searchBarMessage: "Enter a Username",
      dropdownOpen: new Array(2).fill(false),
      searchDropdownOpen: new Array(3).fill(false),
      canPurge: this.props.canPurge
    };
  }

  toggle(i) {
    const newArray = this.state.dropdownOpen.map((element, index) => {
      return index === i ? !element : false;
    });
    this.setState({
      dropdownOpen: newArray
    });
  }

  toggleSearch(i) {
    const newArray = this.state.searchDropdownOpen.map((element, index) => {
      return index === i ? !element : false;
    });
    this.setState({
      searchDropdownOpen: newArray
    });
  }

  async search() {
    let guid = this.textInput.value;

    if (this.state.searchFilter === "Username") {
      guid = await apiCalls.getGlobalId(this.textInput.value)
        .catch((err) => { this.props.handleAPIError(err) })
    }

    if (guid) {
      this.props.updateGUID(guid);
      this.props.setUserInfoLoading(true);
      let metadata = await apiCalls.getMetadata(guid)
        .catch((err) => { this.props.handleAPIError(err); })
      
      let startTime = metadata ? metadata.FirstEngagement.firstTimestamp : null;
      this.props.setUserConversationsLoading(true);
      apiCalls.getConversationsByUser(guid, startTime)
        .then((result) => {
          this.props.setUserConversationsLoading(false);
          this.props.getConversationsByUserId({
            conversations: result,
            guid: guid
          })
        })
        .catch((err) => {
          this.props.setUserConversationsLoading(false);
          this.props.handleAPIError(err);
        })
      
      apiCalls.getLastTask(guid)
        .then(taskRes => { this.props.displayMetadata(metadata, this.textInput.value, taskRes); })
        .catch(err => { this.props.handleAPIError(err); });
    } else {
      this.props.getConversationsByUserId({
        conversations: {
          conversations: [],
          guid: 2
        }
      })
    }
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      this.search();
    }
  }

  setSearchFilter(event) {
    this.setState({
      searchFilter: event.target.value,
      searchBarMessage: `Enter a ${event.target.innerText}`,
      searchTitle: event.target.innerText
    });
    this.props.setSearchFilter(event.target.value);
  }

  render() {
    return (
      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <Button color="primary">
            <i
              className="icon-magnifier icon-magnifier-color icons font-lg"
              onClick={this.search}
            ></i>
          </Button>
        </InputGroupAddon>
        <Input
          innerRef={textInput => {
            this.textInput = textInput;
          }}
          onKeyPress={this.handleKeyPress}
          placeholder={this.state.searchBarMessage}
        />

        {/* SEARCH FILTER */}
        <InputGroupAddon addonType="prepend">
          {/* SEARCH FILTER */}
          <ButtonDropdown
            className=" mr-2"
            isOpen={this.state.searchDropdownOpen[1]}
            toggle={() => {
              this.toggleSearch(1);
            }}
          >
            <DropdownToggle caret color="primary">
              {this.state.searchTitle}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem value="Username" onClick={this.setSearchFilter}>
                Username
              </DropdownItem>
              <DropdownItem
                value="GUID"
                name="Global User Id"
                onClick={this.setSearchFilter}
              >
                Global User ID
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
          <ButtonDropDownWithAuth
            action="destroy"
            pathname={this.props.location.pathname}
            className="mr-1"
            isOpen={this.state.dropdownOpen[1]}
            toggle={() => {
              this.toggle(1);
            }}
            text={[
              <DropdownToggle caret color="primary" key="0">
                Advanced
              </DropdownToggle>,
              <DropdownMenu key="1">
                <DropdownItem
                  disabled={!this.props.canPurge}
                  onClick={this.props.purgeHistory}
                >
                  Purge History
                </DropdownItem>
                <DropdownItem
                  disabled={!this.props.canDeleteUser}
                  onClick={this.props.deleteUser}
                >
                  Delete User
                </DropdownItem>
              </DropdownMenu>
            ]}
          >
          </ButtonDropDownWithAuth>
        </InputGroupAddon>
      </InputGroup>
    );
  }
}

export default UserIdSearch;
